import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'

import { ASSET_OPTIONS } from '@/constants/common'
import { cn } from '@/utils/cn'
import { Check } from '@/components/icon'

import { BottomSheet } from './BottomSheet'

export function WalletEventFilterSheet(props: SheetProps<'wallet-event-filter'>) {
  const { t } = useTranslation()
  const handlePress = (status: string) => {
    props.payload?.setValue(status)
    SheetManager.hide(props.sheetId)
  }

  return (
    <BottomSheet closeDrawer={props.payload?.closeDrawer}>
      {ASSET_OPTIONS.map((kind) => {
        const selected = kind === props.payload?.value
        return (
          <Pressable key={kind} onPress={() => handlePress(kind)}>
            {({ pressed }) => (
              <View className={cn('flex-row justify-between px-4 py-3', pressed && 'bg-background-secondary')}>
                <Text className={cn('text-base text-text-primary', selected && 'text-text-info')}>
                  {t(`asset:filter.${kind}`)}
                </Text>
                {selected && <Check className={'size-6 text-primary'} />}
              </View>
            )}
          </Pressable>
        )
      })}
    </BottomSheet>
  )
}
